var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanchonete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3677 13.3772L18.2543 21.6708L26.141 13.3772H10.3677Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8393 13.3775H3.62258C2.17238 13.3775 1 14.7528 1 16.4461C1 18.1441 2.17238 19.5147 3.62258 19.5147H16.2035L10.3651 13.3728H26.1431L20.3046 19.5147H29.8393C31.2895 19.5147 32.4618 18.1395 32.4618 16.4461C32.4618 14.7481 31.2895 13.3775 29.8393 13.3775Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8408 19.5145H20.3062L26.1447 13.3726H29.8408C30.1846 13.3726 30.5094 13.4522 30.8108 13.5925C30.3258 5.19128 24.2095 1 16.7325 1C9.25546 1 3.13923 5.19128 2.65425 13.5925C2.9556 13.4522 3.28045 13.3726 3.62417 13.3726H10.3714L16.2098 19.5145H3.62888C3.27104 19.5145 2.93203 19.4303 2.62598 19.2806V21.6803C2.62598 22.9527 3.50648 23.9818 4.59413 23.9818H28.885C29.9727 23.9818 30.8531 22.9527 30.8531 21.6803V19.2806C30.5424 19.4303 30.2033 19.5145 29.8502 19.5145H29.8408Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8506 9.98099V10.2102",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1594 8.39624V8.63013",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0646 4.91125V5.14046",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanchonete);
export default __webpack_public_path__ + "static/media/lanchonete.21503a17307473a3d2df108e8d318f9a.svg";
export { ForwardRef as ReactComponent };